export default  {
  resetState: ({ commit }) => commit('resetState'),
  getItem ({ commit, dispatch }, options){
     dispatch('graph', {type: 'project.item', options: options, next: function (response) {
          if (options.next) return options.next(response)
          commit('setProject', response )
     }}, {root: true} )
  },
  getProject ({ commit, dispatch }, options){
     dispatch('graph', {type: 'project.item', options: options, next: function (response) {
          if (options.next) return options.next(response)
          commit('setProject', response )
     }}, {root: true} )
  },
  saveItem ({ commit, dispatch }, options){
     dispatch('graph', {type: 'project.save', options: options, next: function (response) {
          if (options.next) options.next(response)
     }}, {root: true} )
  },
  updateProject ({ commit, dispatch }, options){
     dispatch('graph', {type: 'project.save', options: options, next: function (response) {
          if (options.next) options.next(response)
     }}, {root: true} )
  },
  load ({ commit, dispatch }, options){
     dispatch('graph', {type: 'project.array', options: options, next: function (response, count) {
          commit('setList', response )
          if (options.next) options.next(response)
     }}, {root: true} )
  }
}